import { useState } from "react";

const imgFolder = "./img/exterior/";

function VehicleImage({ model, color, rims }) {
  const imgName = `${model}/${color}_${rims}.png`;

  console.info(imgName);

  return (
    <img
      className="car-interior-image"
      src={`${imgFolder}${imgName}`}
      alt={`M5, ${color}, ${rims}`}
    />
  );
}

function ModelSelector({ value, onModelClick }) {
  return (
    <button className="configurator-parameters-model" onClick={onModelClick}>
      {value}
    </button>
  );
}

function ColorSelector({ value, onColorClick, colorSelected }) {
  const imgName = `m5_icons/${value.toLowerCase()}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        colorSelected === value?.toLowerCase() ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onColorClick}
    />
  );
}

function RimsSelector({ value, onRimsClick, rimsSelected }) {
  const imgName = `m5_icons/rims_${value.toLowerCase()}.png`;

  return (
    <img
      className={`configurator-parameters__color ${
        rimsSelected === value?.toLowerCase() ? "active" : ""
      }`}
      src={`${imgFolder}${imgName}`}
      alt={value}
      onClick={onRimsClick}
    />
  );
}

export default function Exterior() {
  const [modelSelected, setModel] = useState("m5");
  const [colorSelected, setColor] = useState("black");
  const [rimsSelected, setRims] = useState("r19");
  const [rimsToShow, setRimsToShow] = useState("r19");
  const [colorToShow, setColorToShow] = useState("Позолоченный черный");

  function onModelClick(modelClicked) {
    console.warn(modelClicked);
    setModel(modelClicked);
  }

  function onColorClick(colorClicked) {
    console.warn(colorClicked);
    setColor(colorClicked);
  }

  function onRimsClick(rimsClicked) {
    console.warn(rimsClicked);
    setRims(rimsClicked);
  }

  return (
    <>
      <div className="configurator-preview">
        <>
          <VehicleImage
            model={modelSelected}
            color={colorSelected}
            rims={rimsSelected}
          />
        </>
      </div>

      <div className="configurator-parameters-wrapper">
        <div className="carCaption">
          {colorToShow?.toUpperCase()} {rimsToShow?.toUpperCase()}
        </div>
        <div className="configurator-parameters">
          {/* <div className="configurator-parameters-section, hidden">
              <ModelSelector value="M5-1" onModelClick={() => onModelClick("m5")} />
              <ModelSelector value="M5-2" onModelClick={() => onModelClick("m5")} />
            </div> */}
          <div className="configurator-parameters-section">
            <ColorSelector
              value="Black"
              onColorClick={() => {
                onColorClick("black");
                setColorToShow("Позолоченный черный");
              }}
              colorSelected={colorSelected}
            />
            <ColorSelector
              value="icy-crystal-gray"
              onColorClick={() => {
                onColorClick("icy-crystal-gray");
                setColorToShow("Ледяной кристально-серый");
              }}
              colorSelected={colorSelected}
            />
            <ColorSelector
              value="ceramic-white"
              onColorClick={() => {
                onColorClick("ceramic-white");
                setColorToShow("Керамический белый");
              }}
              colorSelected={colorSelected}
            />
            <ColorSelector
              value="green-frosty-pine"
              onColorClick={() => {
                onColorClick("green-frosty-pine");
                setColorToShow("Зеленая морозная сосна");
              }}
              colorSelected={colorSelected}
            />
            <ColorSelector
              value="blue-ocean"
              onColorClick={() => {
                onColorClick("blue-ocean");
                setColorToShow("Синий океан");
              }}
              colorSelected={colorSelected}
            />
          </div>
          <div className="configurator-parameters-section">
            <RimsSelector
              value="R19"
              onRimsClick={() => {
                onRimsClick("r19");
                setRimsToShow("r19");
              }}
              rimsSelected={rimsSelected}
            />
            <RimsSelector
              value="R20"
              onRimsClick={() => {
                onRimsClick("r20");
                setRimsToShow("r20");
              }}
              rimsSelected={rimsSelected}
            />
            {/* <RimsSelector value="R20_2" onRimsClick={() => {onRimsClick("r20_2"); setRimsToShow("r20");}} rimsSelected={rimsSelected} /> */}
          </div>
        </div>
        <div className="carCaption"></div>
      </div>
    </>
  );
}
